"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEventItemType = isEventItemType;
function isEventItemType(itemType) {
    return itemType?.generationType === 'event';
}
//# sourceMappingURL=item.event.guard.js.map